import React,{useEffect,useState} from 'react'
import {
Statistic,

Button,
Select,
Spin
} from 'antd'
import {useSelector,useDispatch} from 'react-redux'
import QNA from './QNA'
import {ReactComponent  as QuizLogo} from './quiz.svg'
const StartQuiz = ()=>{
    const { Option } = Select;
   const [level,setLevel] = useState('easy')
   const dispatch = useDispatch()
   const handleClick = ()=>{
       var points ;
       if(level==='medium'){
           points = 3;
       }else if(level==='hard'){
           points = 6;
       }else{
           points = 1;
       }
       dispatch({type:"REQUEST_QUIZ_START",payload:{
           level:level,
           increasePoints:points
       }})
   }
    return(
        <div style={{display:'flex',justifyContent:'space-around',flexDirection:'column',alignItems:'center'}}>
        <QuizLogo/>
        <Select defaultValue="easy" onChange={(e)=>setLevel(e)} >
            <Option value="easy">Easy</Option>
            <Option value="medium">Medium</Option>
            <Option value="hard">Hard</Option>
        </Select><br/>
        <Button onClick={handleClick} type='primary' shape='round'>START QUIZ !</Button>
        </div>
    )
}

function Quiz(props) {
    const { Countdown } = Statistic;
    const [deadline,setDeadline] = useState(null)
    const user = useSelector(state=>state.user)
    const quiz = useSelector(state=>state.quiz)
    const previousQuizTime = user.lastQuiz;
   
    useEffect(()=>{
        var preDate = new Date(previousQuizTime)
        preDate.setHours( preDate.getHours() + 1 );
        var now = new Date();
        if(now>preDate){
            setDeadline(null)
        }else{
            setDeadline(Date.now() +(preDate-now))
        }
    },[])
    return (
        <div id={quiz.start?"quiz-s":"quiz"}>

        {deadline===null?
            <div>
            {quiz.loading ?<Spin/>:
                <div>
                {quiz.start ?<QNA/>:<StartQuiz/>} 
                </div>}
               
            </div>
            : 
            <Countdown title="Next Quiz After" value={deadline} onFinish={()=>{console.log("finished")}} />}
       
        </div>
    )
}

export default Quiz
